import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrutinyPopupComponent } from '../scrutiny-popup/scrutiny-popup.component';
import { FeeProcessComponent } from '../fee-process/fee-process.component';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ExamFeeProcessComponent } from '../exam-fee-process/exam-fee-process.component';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { PayLaterComponent } from '../pay-later/pay-later.component';

@Component({
  selector: 'app-exam-fee',
  templateUrl: './exam-fee.component.html',
  styleUrls: ['./exam-fee.component.scss']
})
export class ExamFeeComponent implements OnInit {

  APIService: any;
  ApplyFee: FormGroup;
  sessionList: any[];
  SessionFilterList: any[];
  FeeTable: [];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  payBtnShow = false;
  StudentType: '';
  StudentStatus: '';
  Constitution: '';
  Social: '';
  Admission: '';
  Caste: '';
  FeePaid: string;
  Table = false;
  PayLater = true
  feeApplyArray: FormArray;
  constId = 0;
  StuData: any;
  TempCode: any;
  studentId: any;
  Mode: any;
  PayStatus: any;
  dialogRef1: MatDialogRef<any>;
  SessionNo: any;
  ADMRecords: any[];
  Dates: any[];
  ShowMsg = false;
  Message = '';
  Paylater: any;
  FeeDetails: any;
  userPermission: any;
  UserCollege: any;
  filteredCourseList: any;
  ExamAList: any;
  filteredExamAList: any;
  status: string;
  SrNo = 0;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) { this.APIService = environment.serviceUrl; }

 
  ngOnInit(): void {
    this.ShowMsg = false;
    this.PayLater = true
    this.Message = '';
    this.status = '';
    this.SrNo = 0;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
    }
    this.Table = false;
    this.payBtnShow = false;
    let id = ''
    this.StudentType = '';
    this.StudentStatus = '';
    this.Constitution = '';
    this.Social = '';
    this.Admission = '';
    this.Caste = '';
    this.sessionId = 0;
    this.constId = 0;
    this.ApplyFee = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      Exam: new FormControl(''),
      feeApplyArray: new FormArray([]),
    });
    this.fetchSession(id);
    // this.fetchCollege()

  }
  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
    }
    );
  }


  fetchSession(id) {
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }
  getfeeApplyArrayControls() {
    return (this.ApplyFee.get('feeApplyArray') as FormArray).controls;
  }

  // getCourse(id) {
  //   this.Table = false;
  //   this.sessionId = id
  //   this.collegeList = [];
  //   this.filteredCollegeList = [];
  //   const payload = {};
  //   payload['SessionId'] = id;
  //   sessionStorage.setItem("SnNo", id);
  //   this.umsService.fetchIntakeFilter(payload).subscribe(res => {
  //     this.CourseList = res.data;
  //     this.filteredListCourse = this.CourseList.slice();
  //     this.ApplyFee.controls['course'].setValue('')

  //   })
  // }

  // getClg(CoCode) {
  //   this.Table = false;
  //   this.CoCode = CoCode;
  //   this.collegeList = [];
  //   const payload = {};
  //   payload['SessionId'] = this.sessionId;
  //   payload['CoCgCoCode'] = CoCode;
  //   this.umsService.fetchIntakeFilter(payload).subscribe(res => {
  //     this.collegeList = res.data;
  //     this.filteredCollegeList = this.collegeList.slice();
  //     this.ApplyFee.controls['college'].setValue('')

  //   })
  // }

  fetchCollege() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.Table = false;
    this.collegeList = [];
    this.filteredCollegeList = []
    this.ApplyFee.controls['college'].setValue('')
    this.CourseList = [];
    this.filteredCourseList = [];
    this.ExamAList = [];
    this.filteredExamAList = [];
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    this.umsService.getCollege(payload).subscribe(res => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
      else{
        this.spinner.hide();
        this.collegeList = []
        this.filteredCollegeList = []
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      
    });

  }

  fetchCourse(id) {
    this.Table = false;
    this.CourseList = [];
    this.filteredCourseList = [];
    this.ApplyFee.controls['course'].setValue('')
    this.ExamAList = [];
    this.filteredExamAList = [];
    const payload = {};
    payload['CoCgCgCode'] = id;
    payload['SessionID'] = this.ApplyFee.value['SessionId'];
    this.umsService.getSessionColgCo(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      }
      else{
        this.spinner.hide();
        this.CourseList = [];
        this.filteredCourseList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
    });
  }

  fetchSupExamRecord(CoCode) {
    this.SrNo = 0;
    this.spinner.show();
    this.Table = false;
    this.ExamAList = [];
    this.filteredExamAList = [];
    this.ApplyFee.controls['Exam'].setValue('')
    sessionStorage.setItem("CgCode", this.ApplyFee.value['college']);
    sessionStorage.setItem("CoCode",CoCode)
    let payload = {};
    payload['EmCoCode'] = CoCode
    this.umsService.getExam(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamAList = [];
      }
    );
  }

  

  getExmSchedule(EmId,SrNo){
    const payload = {};
    this.Table = false;
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = this.ApplyFee.value['SessionId'];
    this.umsService.getExmSch(payload).subscribe((res) => {
      if(res.status){
        const ExmSch = res.data.find((exam: any) => exam.ShEmId === EmId);
        this.getSupExamEditRecord(ExmSch);
        this.SrNo = SrNo;
      }
      else{
        let data = {};
        data['message'] = 'Exam Not Scheduled';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
      
      
    })
  }

  getSupExamEditRecord(ExmSch){
    this.status = ''
    const payload = {};
    payload['EcInCode'] = 19
    payload['EcOpId'] = parseInt(sessionStorage.getItem('userId'));
    payload['EcShId'] = ExmSch.ShId;
    this.umsService.getSupExamEditRecord(payload).subscribe((res) => {
      if(res.status){
        if(res.data[0]['EcStatus'] == 'O' || res.data[0]['EcStatus'] == 'U'){
          this.status = res.data[0]['EcStatus']
          this.ShowTable(this.ApplyFee.value['college']);
        }
      }
      else{
        this.status = ''
        this.Table = false;
        let data = {};
        data['message'] = 'Exam Form List Not Opened For This Exam';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      
      }
      
    })
  }

  ShowTable(CgCode) {
    this.CgCode = CgCode;
    this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
    this.feeApplyArray.clear();
    // this.spinner.show();
    sessionStorage.setItem("college", CgCode);
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = this.ApplyFee.value['SessionId'];
    payload['CoCode'] = this.ApplyFee.value['course'];
    payload['CgCode'] = this.ApplyFee.value['college'];
    payload['FeeType'] = 'EF';
    payload['EmId'] = this.ApplyFee.value['Exam'];
    this.umsService.getFee(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        
        // this.PayLater = false
        if(this.status == 'U'){
          this.PayLater = true
        }
        else if(this.status == 'O'){
          this.PayLater = false
        }
        this.getFeeModeData();
        this.FeeTable = res.data;
        this.studentId = res.data.StuId;
        this.FeeTable.forEach((element, i) => {
          const creds = this.ApplyFee.controls.feeApplyArray as FormArray;
          creds.push(
            this.fb.group({
              StudentName: new FormControl(element['StuFirstNameEng'] + " " + element['StuMidNameEng'] + " " + element['StuLastNameEng']),
              TemplateName: new FormControl(element['TemplateName']),
              StuType: new FormControl(),
              StuStatus: new FormControl(),
              StuSocial: new FormControl(),
              StuAdm: new FormControl(),
            })
          );
          this.getStudentType(element['StudentType'], i)
          this.getStudentStatus(element['StudentStatus'], i);
          this.getSocial(element['SocialReservation'], i);
          // this.getConstitution(element['constitutional'],i);
          this.getAdmission(element['AdmissionMode'], i);
          // this.getCaste(element['Caste'],i);
          this.SearchFeeDetails(element['TemplateCode'], element['StuId']);
          this.getRgId(element['StuId'])
        });


        // this.submit()

      } else {
        this.PayLater = true
        if (res.message == 'No Data Found') {
          this.Table = false;
          this.PayLater = true
          this.FeeTable = [];
        }

      }

    });

  }

  getFeeModeData() {
    // this.spinner.show();
    const payload = {};
    payload["Session"] = this.ApplyFee.value['SessionId'];
    payload['College'] = this.ApplyFee.value['college']
      this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
        if(res.status){
          this.Mode = res.data[0]['FeeMode']
          this.payBtnShow = true;
          this.Table = true;
        }
        else{
          let data = {};
          data['message'] = 'Add Fee Mode For This Filter!';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.Table = false;
        }
      });
      
      
  }

  checkLock2(item,Payment) {
    if(this.SrNo == 1){
      const payload = {};
      payload['UserId'] = sessionStorage.getItem('userId');
      payload['StudentId'] = item.StuId;
      payload['SessionId'] = this.ApplyFee.value['SessionId'];
      this.umsService.ScrutinyLock(payload).subscribe((res) => {
        if (res.status) {
          let Data = res.data[0]
          if (Data.FinalApproval == true) {
            this.openFeeProcessPopUp(item,Payment)
          }
          else if (Data.FinalApproval != true) {
            let data = {};
            data['message'] = 'Scrutiny Not Approved';
            data['title'] = 'Information';
            data['icon'] = 'fas fa-close';
            this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
  
        } else {
          let data = {};
          data['message'] = 'No Data Found';    //need to confirm
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      }, (ERROR: HttpErrorResponse) => {
      });
    }
    else if(this.SrNo > 1){
      this.openFeeProcessPopUp(item,Payment)
    }
   

  }

  openFeeProcessPopUp(item,Payment) {
    let data = {};
    data['TempCode'] = item.TemplateCode;
    data['StuId'] = item.StuId;
    data['Mode'] = this.Mode;
    data['SessionId'] = this.ApplyFee.value['SessionId'];
    data['CgCode'] = item.CgCode
    data['CoCode'] = item.CoCode;
    data['FeeLevel'] = item.FeeLevel;
    data['Status'] = Payment;
    data['Exam'] = this.ApplyFee.value['Exam']
    const dialogRef4 = this.dialog.open(ExamFeeProcessComponent,
      {
        disableClose: true,
        width: "900px",
        height: 'auto',
        data
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ShowTable(item.CgCode,);
    });
  }

  getStudentType(id, i) {
    const payload = {};
    payload['CdType'] = 'STYPE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuType').setValue(element['CdDesc']);
        });
      }
    });
  }

  getStudentStatus(id, i) {
    const payload = {};
    payload['CdType'] = 'STUST'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuStatus').setValue(element['CdDesc']);
        });
      }
    });
  }

  getSocial(id, i) {
    const payload = {};
    payload['CdType'] = 'SR'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuSocial').setValue(element['CdDesc']);
        });
      }
    });
  }
  getConstitution(id) {
    this.constId = id;
    const payload = {};
    payload['CdType'] = 'CS'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.Constitution = res.data[0]['CdDesc'];
      }
    });
  }
  getAdmission(id, i) {
    const payload = {};
    payload['CdType'] = 'AMODE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuAdm').setValue(element['CdDesc']);
        });
      }
    });
  }
  getCaste(id) {
    const payload = {};
    payload['CategoryId'] = this.constId;
    payload['CasteCode'] = id
    this.umsService.fetchCategory(payload).subscribe((res) => {
      if (res.status) {
        this.Caste = res.data[0]['CasteName']
      }
    });
  }



  SearchFeeDetails(TempCode, StdId) {
    this.PayStatus = [];
    this.Paylater = [];
    this.spinner.show();
    const payload = {
      FeeTemplateCode: TempCode,
      StuId: StdId,
      FeeHistory: 0,
      SnNo: this.ApplyFee.value['SessionId']
    };
 
    try {
      this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
        
        this.spinner.hide();
        if (res.status) {
          let data = 0;
          this.FeeDetails = res.data;
          res.data.forEach((element, i) => {
            data += element.FeeAmt;
          });
          const index = this.FeeTable.findIndex((student: any) => student.StuId === StdId);
          if(res.data[0]['FeeStatus'] == 'N'){
            this.Paylater[index] = true;
            this.PayStatus[index] = false;
          }
          else if(res.data[0]['FeeStatus'] != 'N'){
            if (data === res.data[0]['TotalPaidAmount']) {
              this.PayStatus[index] = true;
              this.FeePaid = 'Fees Paid'
              this.Paylater[index] = false;
            }
            else{
              this.PayStatus[index] = false;
              this.Paylater[index] = false;
            }
          }
          
        } else {
          console.error('Error: API returned unsuccessful status');
        }
      });
    } catch (error) {
      console.error('Error in SearchFeeDetails:', error);
    }
  }
  submit() {
    let payload = {};
    this.ADMRecords = [];
    this.Dates = [];
    payload['SnNo'] = parseInt(this.SessionNo);

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      if (res.status) {
        const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId"));
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];

        if (courseRecords.length > 0) {
          this.ADMRecords = courseRecords.filter(record => record.InCode === 'ADFEE');
        }
        const promises = this.ADMRecords.map(element => {
          let payload = {};
          payload['SessionID'] = element.SessionID;
          payload['CoCgCgCode'] = element.CoCgCgCode;
          payload['CoCgCoCode'] = element.CoCgCoCode;
          payload['InCode'] = element.InCode;
          return this.umsService.findSessionCutOff(payload).toPromise();
        });

        Promise.all(promises).then(results => {
          results.forEach(res => {
            this.Dates.push(...res.data);
          });

          let listCanOpen = false;
          if (this.Dates.length == 0) {
            this.showAlert('Schedule Not Open For This Activity');
            listCanOpen = false;
          }
          else if (this.Dates.length > 0) {
            for (let item of this.Dates) {
              if ((item.CutOffDateFrom.split('T')[0] === todayDateString && todayDateString < item.CutOffDate.split('T')[0]) || (item.CutOffDateFrom.split('T')[0] < todayDateString && todayDateString < item.CutOffDate.split('T')[0])) {
                listCanOpen = true;
                break;
              }
            }
          }


          if (!listCanOpen) {
            for (let item of this.Dates) {
              if (todayDateString > item.CutOffDate.split('T')[0]) {
                this.showAlert('Admission Fee Payment Dates Are Closed For This Course');
                break;
              } else if (todayDateString < item.CutOffDateFrom.split('T')[0]) {
                this.showAlert('Schedule Is Not Open For This Activity');
                break;
              }
            }
          }
          if (listCanOpen == true) {
            this.ShowMsg = false;
            this.Message = '';
          }
        }).catch(error => {
          console.error('Error occurred while fetching Dates:', error);
        });
      } else {
        this.showAlert('First Enter CuttOff Dates For This Course Admission Fee');
      }
    });

  }

  showAlert(message: string) {
    // let data = {
    //   message: message,
    //   title: 'Alert',
    //   icon: 'fas fa-close'
    // };
    // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.ShowMsg = true
    this.Message = message;
  }

  paymentReceipt(item) {
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    sessionStorage.setItem('StuId', item.Studentid);
    let data = {};
    data['StuId'] = item.StuId;
    data['Session'] = item.SessionId
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  OpenPopUp() {
    if(this.FeeDetails != undefined){
      let mergedArray = this.FeeTable.map((item1: any) => {
        const correspondingItem = this.FeeDetails.find((item2: any) => item2.StuId === item1.Studentid);
        return { ...item1, ...correspondingItem };
      });
      mergedArray = this.FeeTable.map(item => {
        return Object.assign({}, item, { SnNo: this.ApplyFee.value['SessionId'] });
      });
      let data = mergedArray
      const dialogRef4 = this.dialog.open(PayLaterComponent,
        {
          disableClose: true,
          width: "900px",
          height: 'auto',
          data
        });
      dialogRef4.afterClosed().subscribe((result) => {
        this.ShowTable(this.ApplyFee.value['college'])
      });
    }
    else if(this.FeeDetails == undefined){
      const mergedArray = this.FeeTable.map(item => {
        return Object.assign({}, item, { SnNo: this.ApplyFee.value['SessionId'] });
      });
      const data = mergedArray;
      const dialogRef4 = this.dialog.open(PayLaterComponent,
        {
          disableClose: true,
          width: "900px",
          height: 'auto',
          data
        });
      dialogRef4.afterClosed().subscribe((result) => {
        this.ShowTable(this.ApplyFee.value['college'])
      });
    }
  }

  getRgId(StuId) {
    const payload = {};
    payload['StuId'] = StuId
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        // this.searchExams2(res.data[0]['RgId'])
        this.GetEcId(res.data[0]['RgId'])
      }
      else {
      }
    })
  }

  searchExams2(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = this.ApplyFee.value['course']
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }

      }
    });
  }

  GetEcId(RgId){
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = this.ApplyFee.value['course']
    this.umsService.GetEcId(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }

      }
    });
  }

  ExmFormSub(EcId, RgId) {
    
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        
      }
      else{
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

}
